// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
export default {
    contactSalesButtonText: "Contact sales",
    enterpriseButtonLink: {
        href: "http://monday.com/trustcenter",
        target: "_self"
    },
    enterpriseButtonText: "Explore our Trust Center",
    enterpriseParagraph: "Enterprise-grade AI infrastructure with built-in protection and security, data privacy, governance, permissions, and compliance.",
    enterpriseTitle: "Enterprise-grade security ",
    forresterButtonText: "Learn more <br />",
    forresterCardTagline: "Motorola achieved",
    forresterCardText: "according to research.",
    gartnerButtonText: "Learn more <br />",
    gartnerCardTagline: "The Leader in",
    gartnerCardText: "Work Management reports.",
    sectionTagline: "Enterprise-ready AI work platform",
    sectionTitle: "Trusted by enterprises. Recognized by industry leaders."
};
